import styled from "@emotion/styled";

export const PageWrapper = styled.div`
    padding-bottom: 80px;
    height: calc(100vh - var(--header-height));
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const TableWrapper = styled.div`
    overflow: scroll;
    padding: 0 32px;
    flex: 1;
`;

export const PageContentWrapper = styled.div`
    padding-bottom: 100px;
    overflow-y: scroll;
    flex-grow: 1;
    padding-left: 32px;
`;

export const PageHeadingWrapper = styled.div`
    margin: 24px 40px;
    
    font-family: Metropolis,serif;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */
    
    /* default/gray/700 */
    color: var(--primary-text);
`;

export const ColumnHeading = styled.h4`
  font-size: var(--font-m);
  font-weight: 500;

  &:first-of-type {
    margin-left: var(--space-s1);
    grid-column-start: 1;
  }
`;

export const ColumnHeadingsWrapper = styled.div`
    display: grid;
    grid-template-columns: 322px repeat(auto-fill, 276px);
    grid-auto-flow: column;    
`;

export const PaginationWrapper = styled.div`
    position: fixed;
    width: calc(100vw - var(--side-nav-width));
    
    height: 72px;
    bottom: 0;
    left: var(--side-nav-width);
    background: var(--white);
    box-shadow: 0px -4px 6px rgba(0, 0, 0, 0.1), 0px -2px 4px rgba(0, 0, 0, 0.06);    
    
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  
    padding: 0 32px;
    //margin-left: var(--side-nav-width);
`;

export const NoContentWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    > svg {
      margin: 20px
    }
    
    > div {
        font-family: Metropolis;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 18px;
        color: var(--color-gray-600);
    }
`;
